import { AssertionError } from './AssertionError';
import { createAsserterThatThrowsType } from './createAsserterThatThrowsType';

// eslint-disable-next-line @trello/no-module-logic
export const assert = createAsserterThatThrowsType(AssertionError);
